import { render, staticRenderFns } from "./close.vue?vue&type=template&id=a95cdd90&scoped=true"
import script from "./close.vue?vue&type=script&lang=js"
export * from "./close.vue?vue&type=script&lang=js"
import style0 from "./close.vue?vue&type=style&index=0&id=a95cdd90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95cdd90",
  null
  
)

export default component.exports